import { cacheSize } from './config';

export function serializeData(data: string[]) {
  return JSON.stringify(data.slice(0, cacheSize));
}
